module.exports = __webpack_public_path__ + "static/media/icon-van.f6ed476a.svg";